import { ExternalLink, Flag } from "lucide-react";

const APPLE_REPORTING_URL = "https://support.apple.com/en-us/102568";
const NCSC_REPORTING_URL = "https://www.ncsc.gov.uk/collection/phishing-scams/report-scam-email";

/**
 * An opt-in, evidence-neutral reporting route for articles about unexpected
 * invitations, phishing or social-engineering risks. It does not label a
 * specific product or party as malicious.
 */
export default function ReportSuspiciousInvitationCallout() {
  return (
    <aside
      className="report-suspicious-invitation-callout rounded-xl border border-[#00D4AA]/35 bg-[#00D4AA]/5 px-5 py-4 text-sm leading-relaxed text-foreground"
      role="note"
      aria-labelledby="report-suspicious-invitation-heading"
      data-testid="report-suspicious-invitation-callout"
    >
      <div className="flex items-start gap-3">
        <Flag className="mt-0.5 h-5 w-5 shrink-0 text-[#008f75] dark:text-[#39e2bf]" aria-hidden="true" />
        <div>
          <h2 id="report-suspicious-invitation-heading" className="font-semibold text-foreground">
            Report a suspicious invitation
          </h2>
          <p className="mt-1.5 text-muted-foreground">
            Do not use unexpected-message links to investigate a claimed offer. Preserve the relevant details, then use an official reporting route. Reporting is a precaution and does not by itself prove a technical compromise.
          </p>
          <ul className="mt-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap" aria-label="Official reporting guidance">
            <li>
              <a
                href={APPLE_REPORTING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-6 items-center gap-1.5 font-medium text-[#007a64] underline underline-offset-2 hover:text-[#005f4d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00D4AA] focus-visible:ring-offset-2 dark:text-[#39e2bf] dark:hover:text-[#77f0d4]"
              >
                Apple security and phishing guidance
                <ExternalLink className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href={NCSC_REPORTING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-6 items-center gap-1.5 font-medium text-[#007a64] underline underline-offset-2 hover:text-[#005f4d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00D4AA] focus-visible:ring-offset-2 dark:text-[#39e2bf] dark:hover:text-[#77f0d4]"
              >
                NCSC: report a scam email
                <ExternalLink className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
}
